import { css } from "lit";
import { formSectionStyles } from "../live-event-form.css";

export const styles = [
  formSectionStyles,
  css`
    .free-event-toggle {
      margin-bottom: 4px;
    }

    .tier-options {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 8px;
    }

    .tier-radio {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 8px;
      align-items: center;
      cursor: pointer;
    }

    .tier-radio input[type="radio"] {
      grid-row: 1 / span 2;
    }

    .tier-radio .tier-title {
      font-weight: 500;
    }

    .tier-radio .tier-desc {
      color: var(--wow-color-text-secondary, #6b6b6b);
      font-size: 0.875rem;
    }

    .form-row {
      container-type: inline-size;
    }

    .form-row wow-input {
      min-width: 0;
    }

    @container (min-width: 296px) {
      .form-row wow-input {
        --wow-input-title-min-height: 2lh;
        --wow-input-title-justify: flex-end;
      }

      .form-row wow-input:last-child {
        --wow-input-label-white-space: normal;
      }
    }
  `,
];
